import api from './api';

export type TaskStatus = 'Pending' | 'In Progress' | 'Complete';

export interface Milestone {
  id: string;
  phase_id: string;
  name: string;
  due_date: string;
  status: TaskStatus;
  weight: number;
  created_at: string;
  updated_at?: string;
}

export interface MilestoneCreate {
  phase_id: string;
  name: string;
  due_date: string;
  weight?: number;
}

export interface MilestoneUpdate {
  name?: string;
  due_date?: string;
  status?: TaskStatus;
  weight?: number;
}

class MilestonesService {
  async getAll(phaseId?: string): Promise<Milestone[]> {
    const params = phaseId ? { phase_id: phaseId } : {};
    const response = await api.get('/milestones/', { params });
    return response.data;
  }

  async getById(id: string): Promise<Milestone> {
    const response = await api.get(`/milestones/${id}`);
    return response.data;
  }

  async create(milestone: MilestoneCreate): Promise<Milestone> {
    const response = await api.post('/milestones/', milestone);
    return response.data;
  }

  async update(id: string, milestone: MilestoneUpdate): Promise<Milestone> {
    const response = await api.patch(`/milestones/${id}`, milestone);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/milestones/${id}`);
  }
}

export const milestonesService = new MilestonesService();

